import {getCurrentVersion} from "@/drc/services/drc-request-service";
import {LOCAL_CONSTS} from "@/common/utils/constants";
import Router from "@/common/router";
import {EventBusCase} from "@/common/configurations/event-bus.js";
import store from "@/common/store";
import * as SERVICE from "@/common/services/common-request-service";
import {logout} from "@/common/services/login-service";

export async function updateApplicationVersion() {
	const response = await getCurrentVersion();
	const backendAppVersion = response.data;
	const frontendAppVersion = getCurrentFrontEndVersion(localStorage.getItem(LOCAL_CONSTS.version), backendAppVersion);
	const currentRoute = Router.currentRoute;
	const routePath = currentRoute.path;
	const routeName = currentRoute.name;

	if (Number(backendAppVersion) !== frontendAppVersion) {
		if (routeName === 'submission-new-project-form' || routePath.includes('submission/new-project-form')) {
			EventBusCase.$emit('redirectToContinueDraft');
		}

		resetToken()
			.then(() => {
				console.warn("Updated user token")
			})
			.catch((error) => {
				console.error(error)
			})
			.finally(() => {
				localStorage.setItem(LOCAL_CONSTS.version, backendAppVersion)
				EventBusCase.$emit('cleanCache')
			});

	}
}

function resetToken() {
	return new Promise((resolve) => {
		const name = store.getters.getUser?.fullName;
		const email = store.getters.getUser?.email;

		if (!name || !email) {
			deleteJwtFromLocalStorage();
			resolve(200)
			Router.push('/login');
		} else {
			const isSso = localStorage.getItem('isSso') === 'true' ? true : false;
			deleteJwtFromLocalStorage();
			SERVICE.login({username: email, fullName: name}, "RESET_TOKEN")
				.then((response) => {
					setJwt(response, isSso);
					resolve(200)
				})
				.catch(() => {
					Router.push('/login');
					throw new Error('failed to login')
				});
		}
	});

}

function deleteJwtFromLocalStorage() {
	localStorage.removeItem('jwt');
	localStorage.removeItem('isSso');
}

function setJwt(response, isSso) {
	let user = response.data;
	user.isSso = isSso;

	if (!user.jwt) {
		logout();
	} else {
		store.dispatch('signIn', response);
	}
}

function getCurrentFrontEndVersion(version, backendAppVersion) {
	if (version) {
		return JSON.parse(version)
	} else {
		localStorage.setItem(LOCAL_CONSTS.version, backendAppVersion)
		return backendAppVersion;
	}
}
